import {
    Box,
    Button,
    Card,
    Container,
    Grid,
    Typography
} from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import RoleFaqsHero from "src/components/role-faqs/RoleFaqsHero";
import {
    ROLE_FAQS_CONTENT,
    type RoleFaqsKey,
} from "../content/roleFaqsContent";

const ROLES: RoleFaqsKey[] = ["athlete", "guardian", "coach", "organization"];

const FAQs: React.FC = () => {
    return (
        <Box>
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Typography
                    variant="h2"
                    component="h1"
                    sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
                >
                    TELL US MORE ABOUT YOU…
                </Typography>
                <Typography
                    variant="h5"
                    component="p"
                    sx={{
                        textAlign: "center",
                        mb: 6,
                        color: "text.secondary",
                        fontStyle: "italic",
                    }}
                >
                    Select your role below to explore your path
                </Typography>

                <Grid container spacing={3} direction="column" gap={3}>
                    {ROLES.map((role) => {
                        const content = ROLE_FAQS_CONTENT[role];
                        return (
                            <Card
                                key={role}
                                elevation={2}
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    transition: "transform 0.2s ease-in-out",
                                    "&:hover": { transform: "translateY(-4px)", boxShadow: 4 },
                                }}
                            >
                                <RouterLink
                                    to={`/faqs/${role}`}
                                    style={{ textDecoration: "none" }}
                                >
                                    <RoleFaqsHero
                                        title={content.title}
                                        intro={content.intro}
                                        heroImageUrl={content.roleSelectImage || "/images/athlete.jpg"}
                                        anchorStrip={<Button component={RouterLink}
                                            variant="contained"
                                            to={`/faqs/${role}`}
                                            sx={{ color: "inherit", textTransform: "none" }}>Explore</Button>}
                                    />
                                </RouterLink>
                            </Card>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default FAQs;
